export const COMPOSITIONS_SET = 'setCompositions';
export const COMPOSITIONS_CURRENT_SET = 'setCurrentComposition';
export const DEACTIVATE_ALL_COMPOSITIONS = 'deactivateAllCompositions';
export const ACTIVATE_CURRENT_COMPOSITION = 'activateCurrentComposition';
export const LAYERS_SET = 'setLayers';
export const LAYERS_LAYERS_ADD = 'addLayersToList';
export const LAYERS_LAYER_DELETE = 'removeLayerFromList';
export const APPEND_LAYER = 'appendLayer';
export const STYLES_SET = 'setStyles';
export const LAYERS_LOADING_SET = 'setLayersLoading';
export const SET_LAYER_VISIBILITY = 'setLayerVisibility';
export const TEMPORARY_LAYER_SET_VISIBILITY = 'temporaryLayerSetVisibility';
export const LAYERS_ADD_WMTS_LAYER_SOURCE = 'layersAddWmtsLayerSource';

export const LAYERS_ADD_WMS_LAYER = 'addWmsLayer';

export const FEATURES_GEOMETRIES_SET = 'setFeaturesGeometries';
export const FEATURES_SET = 'setFeatures';
export const FEATURE_ADD = 'addFeature';
export const FEATURE_DELETE = 'deleteFeature';
export const FEATURE_EDIT = 'editFeature';
export const SELECT_DRAWN_FEATURE_SET = 'setDrawnSelectFeature';

export const FEATURES_COLUMNS_SET = 'setFeaturesColumns';
export const FEATURES_TABLE_META_SET = 'setTableMeta';
export const FEATURES_DICTIONARIES_SET = 'setDictionaries';
export const FEATURES_PREPEND_FROM_SELECTION = 'prependFeaturesFromSelection';
export const FEATURES_COUNT_SET = 'setFeaturesCount';
export const FEATURES_LAYER_SET = 'setFeaturesLayer';
export const FEATURES_TABLE_TOGGLE = 'toggleFeaturesTable';
export const FEATURES_TABLE_PAGE_NUMBER = 'featuresTablePageNumber';
export const FEATURES_TABLE_IS_LOADING = 'featuresTableIsLoading';
export const FEATURES_SELECTED_TOGGLE = 'toggleSelectedFeatures';
export const FEATURES_SHOW_DESELECT = 'hideSelectedFeatures';
export const FEATURES_DELETED_MAP_ITEM = 'featuresDeletedMapItem';
export const FEATURES_TILE_LAYERS_FEATURES_SET =
  'featuresTileLayersFeaturesSet';
export const FEATURES_SELECT_ALL_SET = 'setFeaturesSelectedAll';
export const FEATURES_INDETERMINATE_SET = 'setFeaturesSelectedIndeterminate';
export const FEATURES_INVERTED_SET = 'setFeaturesInverted';
export const FEATURES_IMPORTED_COUNT_SET = 'setImportedFeaturesCount';
export const FEATURES_OFFSET_SET = 'setFeaturesOffset';

export const MAP_CURRENT_VIEW_INDEX_INCREMENT = 'incrementCurrentViewIndex';
export const MAP_CURRENT_VIEW_INDEX_DECREMENT = 'decrementCurrentViewIndex';
export const MAP_VIEW_ADD = 'addView';
export const MAP_LAST_VIEW_REMOVE = 'removeLastView';
export const MAP_VIEW_RESTORING_SET = 'setViewRestoring';
export const MAP_COORDINATE_SYSTEM_SET = 'setCoordinateSystem';
export const MAP_ZOOM_SET = 'setZoom';
export const MAP_RESOLUTION_SET = 'setResolution';
export const MAP_SCALE_SET = 'setScale';
export const VIEW_CENTER_SET = 'viewCenterSet';
export const MAP_HISTORY_DATA_MODE_SET = 'setHistoryDataMode';

export const REPORT_DEMAND_POPUP_SHOW = 'showReportDemandDialog';
export const REPORT_DEMAND_SET_ADDRESS = 'reportDemandSetDialogAddress';
export const REPORT_DEMAND_POPUP_HIDE = 'hideReportDemandDialog';
export const WINDOW_SET_CENTRE_SHOW = 'showSetCentreWindow';
export const WINDOW_SET_CENTRE_HIDE = 'hideSetCentreWindow';
export const WINDOW_SAVE_COMPOSITION_SHOW = 'showSaveCompositionWindow';
export const WINDOW_SAVE_COMPOSITION_HIDE = 'hideSaveCompositionWindow';
export const WINDOW_API_ERROR_SHOW = 'showApiErrorWindow';
export const WINDOW_API_ERROR_HIDE = 'hideApiErrorWindow';
export const WINDOW_MIGRATION_ERROR_SHOW = 'showMigrationErrorWindow';
export const WINDOW_MIGRATION_ERROR_HIDE = 'hideMigrationErrorWindow';
export const WINDOW_GET_LAYER_FROM_FILE_SHOW = 'showGetLayerFromFileWindow';
export const WINDOW_GET_LAYER_FROM_FILE_HIDE = 'hideGetLayerFromFileWindow';
export const WINDOW_ADD_LAYER_FROM_SERVICE_SHOW =
  'showAddLayerFromServiceWindow';
export const WINDOW_ADD_LAYER_FROM_SERVICE_HIDE =
  'hideAddLayerFromServiceWindow';
export const WINDOW_MAP_SHORTCUTS_SHOW = 'showMapShortcutsWindow';
export const WINDOW_MAP_SHORTCUTS_HIDE = 'hideMapShortcutsWindow';
export const WINDOW_DOWNLOAD_TEMPLATE_SHOW = 'showDownloadTemplateWindow';
export const WINDOW_DOWNLOAD_TEMPLATE_HIDE = 'hideDownloadTemplateWindow';
export const WINDOW_NOTIFICATION_SHOW = 'showNotificationWindow';
export const WINDOW_NOTIFICATION_HIDE = 'hideNotificationWindow';
export const WINDOW_FEATURES_TABLE_COLUMNS_SHOW =
  'showFeaturesTableColumnsWindow';
export const WINDOW_FEATURES_TABLE_COLUMNS_HIDE =
  'hideFeaturesTableColumnsWindow';
export const WINDOW_FEATURES_FILTER_SHOW = 'showFeaturesFilterWindow';
export const WINDOW_FEATURES_FILTER_HIDE = 'hideFeaturesFilterWindow';
export const WINDOW_REPORT_WIZARD_SHOW = 'showReportWizardWindow';
export const WINDOW_REPORT_WIZARD_HIDE = 'hideReportWizardWindow';
export const WINDOW_EXPORT_TO_FILE_SHOW = 'showExportToFileWindow';
export const WINDOW_EXPORT_TO_FILE_HIDE = 'hideExportToFileWindow';
export const WINDOW_ASK_FOR_ARCHIVE_DATA_SHOW = 'showAskForArchiveDataWindow';
export const WINDOW_ASK_FOR_ARCHIVE_DATA_HIDE = 'hideAskForArchiveDataWindow';
export const WINDOW_ZOOM_TO_OWN_RANGE_SHOW = 'showZoomToOwnRangeWindow';
export const WINDOW_ZOOM_TO_OWN_RANGE_HIDE = 'hideZoomToOwnRangeWindow';
export const WINDOW_FIELDS_CALCULATOR_SHOW = 'showFieldsCalculatorWindow';
export const WINDOW_FIELDS_CALCULATOR_HIDE = 'hideFieldsCalculatorWindow';
export const FEATURES_TABLE_ACTIVE_TAB_SET = 'setFeaturesTableActiveTab';
export const WINDOW_DEMAND_FORM_SHOW = 'showDemandFormWindow';
export const WINDOW_DEMAND_FORM_HIDE = 'hideDemandFormWindow';
export const WINDOW_DEMAND_EXPORT_SHOW = 'showDemandExportWindow';
export const WINDOW_DEMAND_EXPORT_HIDE = 'hideDemandExportWindow';
export const WINDOW_MAP_PERMALINK_MODAL_SHOW = 'showMapPermalinkModalWindow';
export const WINDOW_MAP_PERMALINK_MODAL_HIDE = 'hideMapPermalinkModalWindow';
export const WINDOW_SEARCH_RESULT_FILTER_SHOW = 'showSearchResultFilterWindow';
export const WINDOW_SEARCH_RESULT_FILTER_HIDE = 'hideSearchResultFilterWindow';
export const MAP_ZOOM_MODE_TOGGLE = 'toggleMapZoomMode';

export const WINDOW_HISTORY_FILTER_SHOW = 'showHistoryFilterWindow';
export const WINDOW_HISTORY_FILTER_HIDE = 'hideHistoryFilterWindow';
export const WINDOW_HISTORY_DETAILS_SHOW = 'showHistoryDetailsWindow';
export const WINDOW_HISTORY_DETAILS_HIDE = 'hideHistoryDetailsWindow';

export const KEYSHORTCUTS_CURRENT_ADD = 'addCurrentShortcut';
export const KEYSHORTCUTS_CURRENT_REMOVE = 'removeCurrentShortcut';

export const TOOLS_FETCHED_SET = 'setToolsFetched';
export const TOOLS_SET = 'setTools';
export const TOOLS_SHOW_ALL = 'showAllTools';
export const LEFT_RESIZABLE_PANEL_EXPAND_CHANGE =
  'changeLeftResizablePanelExpand';
export const RIGHT_RESIZABLE_PANEL_EXPAND_CHANGE =
  'changeRightResizablePanelExpand';
export const REPORTS_RANGE_SELECTION_ACTIVATE =
  'activateFeaturesRangeSelection';
export const REPORTS_RANGE_SET = 'setRange';
export const REPORT_VALIDATION_ERRORS_SET = 'setValidationErrors';
export const REPORT_VALIDATION_CHOOSEN_OBJECT_PROPERTIES_SET =
  'setValidationChoosenObject';
export const REPORT_VALIDATION_PUBLISH_FINISHED_AUTOMATICALLY_SET =
  'setPublishFinishedAutomatically';
export const REPORT_LOCKED_SET = 'setReportWizardLocked';

export const DATA_FEED_ID_SET = 'setDataFeedId';
export const DATA_FEED_TYPE_SET = 'setDataFeedType';
export const DATA_FEED_REPORT_LOADED_SET = 'setDataFeedReportLoaded';
export const DATA_FEED_NO_GEOMETRY_LAYER_ID_SET =
  'setDataFeedNoGeometryLayerId';

export const CLAUSES_SET = 'setClauses';

// export const EDIT_SESSION_FEATURE_SELECTED = 'editSessionFeatureSelected';
// export const EDIT_SESSION_FEATURE_DESELECTED = 'editSessionFeatureDeselected';

export const EDIT_SESSION_CREATE_MAP_LAYER = 'createEditModeMapLayer';

export const EDIT_SESSION_SET_SESSION = 'editSession';
export const MANUAL_IMPORT_PANEL_VISIBLE_SET = 'manualImportPanelVisible';
export const MANUAL_IMPORT_FEATURE_ID_LENGTH = 'featureIdLength';
export const MANUAL_IMPORT_FEATURES_VALID_RULES = 'featuresValidRules';
export const MANUAL_IMPORT_FEATURES_VALID_RULES_SET =
  'manualImportFeaturesValidRulesSet';
export const MANUAL_IMPORT_FEATURES_VALIDATION_RESULTS =
  'manualImportFeaturesValidationResults';
export const MANUAL_IMPORT_FEATURES_VALIDATION_RESULTS_SET =
  'manualImportFeaturesValidationResultsSet';
export const MANUAL_IMPORT_MAP_TOOLS_SET = 'editSessionMapToolsSet';
export const EDIT_SESSION_UPDATE_SETTINGS = 'editSessionUpdateSettings';
export const EDIT_SESSION_FEATURES_ARE_COPYING_SET =
  'editSessionFeaturesAreCopyingSet';
export const MANUAL_IMPORT_FOCUS_FEATURE_ID_SET =
  'editSessionFocusFeatureIdSet';

export const SELECTED_SEARCH_SET_ITEMS = 'selectedSearchSetItems';

export const SPATIAL_ANALYSIS_SHOW_MODAL = 'showSpatialAnalysisModal';
export const SPATIAL_ANALYSIS_HIDE_MODAL = 'hideSpatialAnalysisModal';

export const SPATIAL_TABS_MODAL_HIDDEN = 'spatialTabsModalHidden';
export const CREATE_DRAWN_FEATURE = 'createDrawnFeature';
export const SET_FEATURE_ENDING = 'setFeatureEnding';
export const END_DRAWING = 'endDrawing';
export const REMOVE_DRAW_INTERACTION = 'removeDrawInteraction';

export const MEASUREMENTS_ENABLED_SET = 'enableMeasurement';
export const MEASUREMENTS_SHOW_MODAL = 'showMeasurementsModal';

export const TEMPORARY_LAYER_MODAL_HIDDEN = 'temporaryLayerModalHidden';

export const SELECT_FEATURE_POPUP_HIDE = 'hideFeaturePopup';
export const SELECT_FEATURE_POPUP_SHOW = 'showFeaturePopup';
export const SELECT_FEATURE_DROPDOWN_HIDE = 'hideFeatureDropdown';
export const SELECT_FEATURE_DROPDOWN_SHOW = 'showFeatureDropdown';
export const SELECT_FEATURE_FROM_DROPDOWN = 'selectFeatureFromDropdown';
export const SET_AUTH_CONTEXT = 'setAuthContext';
export const SELECT_CONTROL_SET = 'setSelectControl';
export const SELECT_MODE_SET = 'setSelectMode';
export const SELECT_MULTIPLE_ACTIVATE = 'activateMultipleSelection';

export const SEARCH_ADDRESS_SET_SELECTED_OBJECT =
  'searchAddressSetSelectedObject';
export const SEARCH_MILEAGE_SET_RESULT = 'setSearchMileageResult;';
export const SEARCH_TERYT_SET_RESULT = 'setSearchTerytResult';
export const SEARCH_TERYT_PARCEL_SET_RESULT = 'setSearchTerytParcelResult';
export const SEARCH_COORDINATE_SET_RESULT = 'setSearchCoordinateResult';
export const SEARCH_ADDRESS_SET_RADIUS = 'setSearchRadius';
export const SEARCH_ADDRESS_SET_GEOMETRY_SEARCH_RADIUS =
  'setSearchByGeometryRadius';

export const SEARCH_LOADER_SHOW = 'showSearchLoader';
export const SEARCH_LOADER_HIDE = 'hideSearchLoader';
export const SEARCH_RESULTS_LOADER_SHOW = 'showSearchResultsLoader';
export const SEARCH_RESULTS_LOADER_HIDE = 'hideSearchResultsLoader';
export const SEARCH_PANEL_TOGGLE_VISIBILITY = 'toggleSearchPanelVisibility';
export const SEARCH_PANEL_SET_ITEMS = 'setFoundItems';
export const SEARCH_MODE_BY_POINT_ENABLE = 'enableSearchModeByPoint';
export const SEARCH_MODE_BY_RECTANGLE_ENABLE = 'enableSearchModeByRectangle';
export const SEARCH_MODE_BY_POLYGON_ENABLE = 'enableSearchModeByPolygon';
export const SEARCH_MODE_BY_GEOMETRY_DISABLE = 'disableSearchModeByGeometry';

export const MISMATCH_AREA_MODE_ENABLED = 'enabledMismatchAreaMode';
export const MISMATCH_POINT_MODE_ENABLED = 'enableMismatchPointMode';
export const MISMATCH_OBJECTS_MODE_ENABLED = 'enableMismatchObjectsMode';
export const MISMATCH_DISABLE_MODES = 'disabledMismatchModes';
export const MISMATCH_AREA_SET = 'setMismatchArea';
export const MISMATCH_POINT_SET = 'setMismatchPoint';
export const MISMATCH_OBJECTS_SET = 'setMismatchObjects';

export const RESPONSIVENESS_WIDTH_SET = 'setWindowWidth';
export const ROAD_LANE_FEATURE_SET_ENDING = 'roadLaneFeatureSetEnding';
export const ROAD_LANE_FEATURE_ADD_POINT_MANUALLY =
  'roadLaneFeatureAddPointManually';
export const ROAD_LANE_POINT_CHANGED = 'roadLanePointChanged';
export const ROAD_LANE_FEATURE_DELETE_POINT = 'roadLaneFeatureDeletePoint';

export const REPLACE_GEOMETRY_STATE_SET = 'setReplaceGeometryState';

export const HISTORY_SET_RESULT = 'setHistoryTableResult';
export const HISTORY_SET_DETAILS_ID = 'setHistoryObjectDetailsId';
export const CONNECTION_ANALYSIS_TOGGLE = 'connectionAnalysisLaunch';
export const CONNECTION_ADD_FEATURE_POINT =
  'connectionAnalysiscAddFeaturePoint';
export const CONNECTION_DELETE_POINT = 'connectionAnalysisDeletePoint';
export const CONNECTION_SET_FEATURE_ENDING =
  'connectionAnalysisSetFeatureEnding';
export const CONNECTION_END_DRAWING = 'connectionAnalysisEndDrawing';
export const CONNECTION_ADD_FEATURE_POINT_MANUALLY =
  'connectionAddFeaturePointManually';
export const CONNECTION_POINT_CHANGED = 'connectionPointChanged';

export const SET_FEATURE_GEOMETRY_ACTIVE = 'setFeatureGeometryActive';
export const SET_FEATURE_GEOMETRY_READY = 'setFeatureGeometryReady';
export const SET_FEATURE_GEOMETRY_FEATURE_SET_ENDING =
  'setFeatureGeometryFeatureSetEnding';
export const SET_FEATURE_GEOMETRY_FEATURE_ADD_POINT_MANUALLY =
  'setFeatureGeometryFeatureAddPointManually';
export const SET_FEATURE_GEOMETRY_POINT_CHANGED =
  'setFeatureGeometryPointChanged';
export const SET_FEATURE_GEOMETRY_FEATURE_DELETE_POINT =
  'setFeatureGeometryFeatureDeletePoint';
export const SET_FEATURES_WITH_COORDINATES = 'setFeatureCoordinates';

export const SET_ALL_LAYERS = 'setAllLayers';
export const TOGGLE_LAYER_VISIBILITY_BY_ID = 'toggleLayerVisibilityById';
export const ADD_TEMPORARY_LAYER_TO_USER_LAYERS =
  'addTemporaryLayerToUserLayers';

export const SYSTEM_LAYERS_EXPANDED_SET = 'setSystemLayersExpanded';
export const MVT_LAYERS_EXPANDED_SET = 'setMvtLayersExpanded';
export const PWID_LAYERS_EXPANDED_SET = 'setPwidLayersExpanded';
export const ARCHIVE_LAYERS_EXPANDED_SET = 'setArchiveLayersExpanded';
export const USER_LAYERS_EXPANDED_SET = 'setUserLayersExpanded';
export const COMPOSITION_LAYERS_EXPANDED_SET = 'setCompositionLayersExpanded';
export const BACKGROUND_LAYERS_EXPANDED_SET = 'setBackgroundLayersExpanded';

export const RESIZABLE_PANEL_FORCE_EXPANDED_SET = 'setResizablePanelExpanded';
export const SET_APPLIED_FILTERS = 'setAppliedFilters';
export const DISPLAY_CLOSEST_OBJECT_INFO = 'displayClosestObjectInfo';
export const CLOSE_OBJECT_DETAILS_WINDOW = 'closeObjectDetailsWindow';

export const RESPONSIVE_VERSION_SET_IF_MOBILE_DEVICE =
  'setIfMobileDeviceResponsiveVersion';
export const RESPONSIVE_VERSION_SET_IF_MOBILE_VERSION =
  'setIfMobileVersionResponsiveVersion';

export const SHOW_CONTEXT_ASSISTANT_MODULE = 'showContextAssistantModule';
export const HIDE_CONTEXT_ASSISTANT_MODULE = 'hideContextAssistantModule';
export const TOGGLE_CONTEXT_ASSISTANT = 'toggleContextAssistant';

export const TOGGLE_HISTORY_TIMELINE_ACTIVE = 'toggleHistoryTimelineActive';
export const SET_HISTORY_TIMELINE_INVENTARIZATION =
  'setHistoryTimelineInventarization';
export const SET_HISTORY_TIMELINE_INVENTARIZATIONS =
  'setHistoryTimelineInventarizations';
export const SET_HISTORY_TIMELINE_ORGANIZATION =
  'setHistoryTimelineOrganization';
export const SESSION_TIME_SET = 'setSessionTime';
export const SESSION_INTERVAL_SET = 'setSessionInterval';
export const SESSION_INTERVAL_CLEAR = 'clearSessionInterval';

